const dictionary = {
  copyright: "Все права защищены",
  cancel: "Отказаться",
  submit: "Отправить",
  reject: "Отклонить",
  accept: "Принять",
  "update-contact-info": "Обновите свои контактные данные здесь",
  logout: "Выйти",
  profile: "Профиль",
  delegation: "Деловое партнерство",
  agree: "Подтверждаю",
  users: "Пользователи",
  "user-cases": "Публикации",
  "connection-error":
    "Произошла ошибка соединения, пожалуйста, попробуйте снова позднее.",
  search: "Поиск",
  edit: "Обновить",
  delete: "Убрать",
  user: "Гражданин",
  lawyer: "Представитель",
  admin: "Руководитель (администратор)",
  agent: "Модератор",
  premium: "Премиум",
  "create-date": "Дата создания",
  selected: "Выбрано",
  approve: "Подтвердить",
  confirm: "Подтвердить",
  abort: "Отмена",
  error:
    "Ваша операция не может быть выполнена, пожалуйста, попробуйте снова позднее",
  success: "Ваша операция выполнена",
  "rows-per-page": "Диапазон списка",
  active: "Активен",
  deactive: "Остановлен",
  pending: "Ждет подтверждения",
  rejected: "Отклонен",
  on_hold: "Приостановлен",
  homepage: "Главная страница",
  save: "Сохранить",
  update_contact_info:
    "Пожалуйста, обновите свои контактные данные прежде, чем продолжить",
  review: "Изучить",
  "my-cases": "Мои публикации",
  "my-offers": "Мои предложения",
  "incoming-offers": "Предложения, которые вы получили",
  "has-no-offer": "В настоящее время у вас нет предложений",
  "contact-us": "Свяжитесь с нами",
  "privacy-policy": "Политика конфиденциальности",
  faq: "Часто задаваемые вопросы",
  "how-to": "Как это сделать",
  "app-require-online":
    "Для использования этого приложения требуется подключение к Интернету.",

  // Login
  login: "Вход",
  register: "Зарегистрироваться",
  forgotPassword: "Я забыл свой пароль",
  email: "Электронная почта",
  "email-required": "Необходимо заполнить поле для электронной почты",
  "email-pattern":
    "Неверный формат электронной почты, пожалуйста, введите действительный адрес электронной почты.",
  password: "Пароль",
  changePassword: "Изменить пароль",
  "password-required": "Необходимо заполнить поле с паролем",
  googleLogin: "Вход через Google",
  signInWithApple: "Вход через Apple",
  googleRegister: "Зарегистрироваться через Google",
  fpSuccess:
    "Ссылка для обновления пароля была отправлена на ваш адрес электронной почты, пожалуйста, проверьте вашу почту.",
  fpError:
    "Возникла проблема при обработке вашего запроса на обновление пароля, пожалуйста, попробуйте позже.",
  enterCaptcha: "Пожалуйста, введите код подтверждения.",
  captchaError: "Пожалуйста, завершите проверку безопасности.",
  captchaFetchError:
    "Произошла ошибка при получении кода подтверждения, пожалуйста, попробуйте позже.",
  loginError: "Вы ввели неверный адрес электронной почты или пароль.",
  userExists:
    "С этим адресом электронной почты уже существует созданный аккаунт, при желании вы можете воспользоваться функцией «Забыли пароль».",
  userBlocked: "Ваш аккаунт заблокирован.",
  enterVerificationCode:
    "Пожалуйста, введите код, отправленный на ваш адрес электронной почты:",
  verificationFailed: "Ошибка подтверждения",
  registerSuccess: "Ваш аккаунт создан, вы можете войти в приложение.",
  userAgreementAccept:
    "Я прочитал, понял и принимаю условия пользовательского соглашения.",
  userNotExists:
    "Не найдено учетной записи с этим адресом электронной почты, пожалуйста, зарегистрируйтесь сначала.",
  userAlreadyExists:
    "С этим адресом электронной почты уже существует созданный аккаунт, при желании вы можете воспользоваться функцией «Забыли пароль».",
  invalidCaptcha:
    "Недействительный код подтверждения, пожалуйста, попробуйте снова.",
  invalidEmail:
    "Недействительный адрес электронной почты, пожалуйста, попробуйте снова.",

  // Forgot Password
  "reset-password": "Обнуление пароля",
  "new-password": "Введите новый пароль",
  "new-password-validate": "Введите новый пароль еще раз",
  "invalid-hash": "Недействительный код",
  "new-password-not-valid":
    "Пожалуйста, введите пароль длиной не менее 6 и не более 50 символов.",
  "new-password-not-comply":
    "Пароли не совпадают, пожалуйста, введите пароль повторно для подтверждения.",
  "reset-successful":
    "Ваш пароль успешно обновлён, вы можете перейти на страницу входа и авторизоваться.",

  // Homepage
  "search-post": "Поиск объявлений...",
  "new-case": "Новое объявление",
  "new-delegation": "Новое партнёрство",
  "open-cases": "Ваши опубликованные объявления",
  budget: "Бюджет",
  "greet-lawyer":
    'Привет, {0}! У вас ещё нет партнёрств, чтобы создать новое, <a href="/delegation/new">нажмите здесь</a>.',
  "greet-user":
    'Привет, {0}! У вас ещё нет объявлений, чтобы создать новое, <a href="/case/new">нажмите здесь</a>.',
  "are-you-lawyer":
    'Вы адвокат? <a href="/profile">Перейдите на страницу профиля, чтобы подать заявку</a>.',
  "most-used-case-categories": "Наиболее часто используемые категории",
  "most-offered-cases": "Объявления с наибольшим количеством предложений",
  "most-hand-shake-cases": "Объявления, по которым достигнута договорённость",
  "see-more-cases": "У вас есть ещё {0} объявлений, нажмите, чтобы посмотреть.",
  "your-offers": "Ваши предложения",
  "your-cases": "Ваши объявления",
  "your-partnerships": "Ваши партнёрства",

  // Profile
  "your-profile": "Информация о вашем профиле",
  "user-id": "Номер пользователя",
  "first-name": "Имя",
  "last-name": "Фамилия",
  "profile-email-pattern":
    "Пожалуйста, введите действующий адрес электронной почты.",
  "profile-email-required": "Адрес электронной почты обязателен.",
  "phone-number": "Номер телефона",
  "profile-phone-pattern": "Пожалуйста, введите действующий номер телефона.",
  "profile-phone-required": "Номер телефона обязателен.",
  "profile-first-name-pattern": "Пожалуйста, введите действительное имя",
  "profile-first-name-required": "Необходимо указать имя",
  "profile-first-name-maxLength": "Имя не должно быть очень длинным",
  "profile-last-name-pattern": "Пожалуйста, укажите действительную фамилию.",
  "profile-last-name-required": "Фамилия не должна быть слишком длинной",
  "user-saved": "Ваши данные сохранены",
  "user-save-failed": "Во время сохранения ваших сведений произошла ошибка",
  "lawyer-registration-info":
    "Если у вас есть регистрация в коллегии адвокатов, вы можете войти в эти поля",
  "lawyer-bar-info": "Ваши подтвержденные данные коллегии адвокатов:",
  "lawyer-pending-info": "Ваша заявка находится на стадии подтверждения.",
  "bar-no": "Номер коллегии адвокатов",
  "bar-no-minLength": "Номер коллегии должен состоять из 5 цифр.",
  "bar-no-maxLength": "Номер коллегии должен состоять из 5 цифр.",
  "bar-no-validate": "Номер и название коллегии должны вводиться вместе.",
  "bar-name": "Название коллегии адвокатов",
  "bar-name-minLength": "Название коллегии должно содержать не менее 10 букв",
  "bar-name-maxLength":
    "Название коллегии должно содержать не более 100 символов.",
  "bar-name-validate": "Номер и название коллегии должны вводиться вместе.",
  "bar-name-pattern": "Название коллегии должно состоять только из букв",
  "profile-roles-validate":
    "Для роли представителя необходимо ввести номер и название коллегии.",
  "enter-code": "Введите код сюда",
  "send-code": "Отправить код",
  "validate-code": "Подтвердить код",
  "wrong-code": "Неверный код!",
  "lawyer-sign-up": "Подать заявку",
  "id-photos": "Фотографии удостоверения личности (сзади и спереди)",
  "id-photos-rules":
    "Пожалуйста, загрузите переднюю и заднюю стороны удостоверения коллегии адвокатов в формате 'jpg', размер файла не должен превышать {0} КБ.",
  "id-photos-size-error": "Размер файла не должен превышать {0} КБ.",
  "id-photos-missing":
    "Пожалуйста, выберите две фотографии удостоверения личности — с передней и задней стороны — для заявки на роль представителя.",
  "lawyer-application": "Заявка на адвокатуру",
  "select-file": "Выбрать файл",
  "doc-save-failed":
    "Загрузка документа не удалась, пожалуйста, попробуйте позже",
  "lawyer-application-success":
    "Ваша заявка на адвокатуру была отправлена, пожалуйста, дождитесь её подтверждения.",
  "lawyer-application-legal-warning":
    "Уважаемые участники! <b>;<br/><br/> Здесь вы можете зарегистрироваться и подать заявку на добавление вас в систему в качестве представителя. С этим заявлением вы уведомляете нас о том, что являетесь адвокатом, состоящим в Турецком союзе адвокатов...",
  lawyerAgreementAccept:
    "Я принимаю вышеуказанные обязательства и ответственность.",
  "deactivate-user": "Удалить аккаунт",
  "deactivate-user-info": `
    При удалении вашей учетной записи все ваши объявления будут остановлены, а ваши предложения закроются.
    Другие пользователи больше не смогут видеть ваши объявления и предложения.
    Вам потребуется зарегистрироваться снова с вашим адресом электронной почты, связанным с вашей учетной записью, когда вы захотите войти в систему.
    <br/><br/>
    Вы уверены, что хотите удалить свою учетную запись?
  `,
  "user-deactivated": "Ваша учетная запись удалена.",
  "user-deactivate-failed":
    "Не удалось удалить учетную запись, пожалуйста, попробуйте позже.",

  // Notifications
  notifications: "Уведомления",
  new_offer_title: "У вас новое предложение",
  new_offer_description:
    "Вы получили предложение по вашему объявлению номер {0}.",
  "mark-as-read": "Отметить как прочитанное",
  offer_accepted_title: "Ваше предложение принято",
  offer_accepted_description:
    "Ваше предложение по объявлению №{0} было принято владельцем объявления. Вы можете посетить страницу объявления и в разделе «Мои предложения» найти контактные данные владельца.",
  offer_rejected_title: "Ваше предложение отклонено",
  offer_rejected_description:
    "Ваше предложение по объявлению №{0} было отклонено владельцем объявления. Вы можете просмотреть причину отклонения в своем профиле.",
  offer_published_title: "Ваше предложение отправлено",
  offer_published_description:
    "Ваше предложение по объявлению №{0} было успешно отправлено. Теперь вы можете ждать ответа от владельца объявления.",
  case_approved_title: "Ваше объявление подтверждено",
  case_approved_description:
    "Ваше объявление №{0} опубликовано, зарегистрированные в нашей системе представители могут видеть ваше объявление и делать предложения.",
  case_rejected_title: "Ваше объявление отклонено",
  case_rejected_description:
    "Ваше объявление №{0} было отклонено. Вы можете просмотреть причину отклонения в своем профиле.",
  lawyer_application_approved_title:
    "Ваша заявка на представительство одобрена.",
  lawyer_application_approved_description:
    "Поздравляем, теперь вы можете просматривать объявления и делать предложения.",
  lawyer_application_rejected_title:
    "Ваша заявка на представительство отклонена.",
  lawyer_application_rejected_description:
    "К сожалению, для того чтобы стать представителем, вам необходимо выполнить следующие условия: {2}",

  // Cases
  "pending-cases": "Ожидает подтверждения",
  "rejected-cases": "Отклонено",
  "inactive-cases": "Не опубликовано",
  "on-hold-cases": "На ожидании",
  "more-case-with-premium":
    "Лимит на размещение объявлений для вашего аккаунта составляет {0} объявлений, вы можете перейти на премиум-аккаунт, чтобы размещать больше объявлений.",
  "your-case-limit": "Всего у вас есть право разместить {0} объявлений.",

  // CaseItem Details
  case: "Публикация",
  "case-code": "Код публикации",
  "missing-case-id-in-url":
    "Информация об объявлении недоступна, в адресе отсутствует номер объявления",
  "case-category-selection": "Тема",
  "please-select-main-category": "Пожалуйста, выберите тип услуги",
  "please-select-sub-category": "Пожалуйста, выберите предмет услуги",
  "main-category-info": `Уважаемый пользователь! Согласно нашим законам, АДВОКАТЫ имеют право вести дела по всем юридическим вопросам. Однако у адвокатов есть право выбора, в каких делах они хотят участвовать. Также в настоящее время наблюдается, что адвокаты специализируются и склонны работать преимущественно с определёнными категориями дел. Поэтому правильный выбор темы вашего дела поможет вам быстрее и проще найти адвоката, который специализируется или стремится специализироваться именно в той области, где вам нужна юридическая помощь. Для удобства выбора все темы разделены на три основные категории: Уголовные дела, Гражданские дела и Прочие вопросы. Каждая из этих категорий, в свою очередь, разбита на различные подкатегории и основные направления. Пожалуйста, делайте свой выбор внимательно. Ваши предпочтения будут проверены и подтверждены нашими специалистами по контролю качества. В результате проверки объявления с ошибками, неполными или неприемлемыми данными либо будут исправлены и опубликованы, либо удалены с сайта.`,
  back: "Назад",
  next: "Вперед",
  "case-city-selection": "Локация",
  "please-select-case-city": "Город подачи иска",
  "please-select-user-city": "Город проживания",
  "case-description": "Примечания",
  "please-enter-short-desc":
    "Пожалуйста, введите краткое описание вашей проблемы, которую вы хотите решить.",
  "please-enter-long-desc": "Хотите предоставить подробную информацию?",
  "please-write-here": "Напишите здесь...",
  "please-write-category": "Введите интересующую вас тему...",
  summary: "Краткие сведения",
  "please-review-case-details": "Введённая информация",
  "case-type": "Основная категория иска",
  "case-sub-type": "Подкатегория иска",
  "case-city": "Город суда (судебное учреждение)",
  "user-city": "Город истца",
  "case-short-desc": "Краткое описание",
  "case-long-desc": "Подробное описание",
  "upgrade-to-premium": "Обновите до Премиум сейчас",
  "short-desc-required":
    "Пожалуйста, введите краткое описание длиной не менее 50 символов.",
  "short-desc-minLength":
    "Продолжайте писать, чтобы достичь минимум 50 символов.",
  "short-desc-maxLength": "Можно ввести не более 500 символов",
  "budget-required": "Пожалуйста, введите цену.",
  "budget-min": "Введённое число должно быть не менее 100.",
  "give-offer": "Сделать предложение",
  "lawyer-offer-text":
    "Пожалуйста, введите описание длиной не менее 50 символов для вашего потенциального клиента...",
  "min-offer-price-error": "Минимально допустимая сумма для ввода: {0}",
  "empty-offer-description-error":
    "Пожалуйста, напишите краткий текст описания.",
  "lawyer-description-legal-warning-header":
    "Пожалуйста, прочитайте и подтвердите следующий текст:",
  "lawyer-description-legal-warning": `Уважаемый пользователь-адвокат! В описании вашего предложения вы можете кратко рассказать о себе, чтобы сделать его более качественным и информативным. Предложения, содержащие юридические разъяснения и рекомендации по спору, а также те, которые противоречат «Договору участия в Vekilet» и законам, не будут приняты. Вы можете отправить своё предложение, нажав кнопку «Отправить». Обращаем ваше внимание, что отправляя предложение, вы соглашаетесь с тем, что в случае, если содержание описания вашего предложения будет противоречить «Договору участия в Vekilet» или законодательству, вся уголовная и юридическая ответственность будет лежать лично на вас`,
  "type-more-with-premium":
    "Для использования большего количества символов вы можете перейти на премиум-аккаунт.",
  "max-char-reached": "Вы достигли максимального лимита символов.",
  "more-offers-with-premium":
    "Вы использовали {0} из {1} доступных предложений, с премиум-аккаунтом вы можете делать неограниченное количество предложений!",
  "see-offers": "Посмотреть предложения ({0})",
  "contact-choice": "Предпочтительный способ связи",
  contact: "Контактные данные",
  "case-saved":
    "Ваш запрос на объявление получен, после проведения необходимых проверок оно будет опубликовано.",
  "please-select-one-contact-choice":
    "Пожалуйста, выберите хотя бы один вариант.",
  EMAIL: "Электронная почта",
  PHONE: "Телефон",
  IN_PERSON: "Лично",
  "change-short-desc": "Здесь вы можете указать примечания",
  "low-budget": "Низкий (₺)",
  "mid-budget": "Средний (₺₺)",
  "high-budget": "Высокий (₺₺₺)",
  "unset-budget": "Не хочу указывать",
  kvkk: `Настоящим подтверждаю и заявляю о том, что: <br/><br/>• Данное объявление и текст соответствует всем применимым законам и директивам, а также «Договору участия в Vekilet», который я лично утвердил, направляя заявку на членство; <br/><br/>• Я дал свое согласие на публикацию информации, относящейся к объявлению и принадлежащей мне, подтвердив свое согласие на сайте; <br/><br/>• Я лично несу всю уголовную и юридическую ответственность за любое содержание, размещённое в объявлении; <br/><br/>• Владелец данного веб-сайта не несёт никакой ответственности за текст объявления, который был написан и подготовлен мной лично. <br/><br/>• Заранее принимаю на себя все обязательства, утвердив данный текст.`,
  "description-info": `Уважаемый пользователь! В этом разделе мы просим вас предоставить краткую информацию, которая поможет определить суть вашего юридического спора. Очень важно не размещать информацию, которая может быть признана преступной или которая в будущем может негативно повлиять на ход вашего судебного разбирательства. <br/><br/>Пожалуйста, формулируйте свои объяснения внимательно, понятным языком и кратко, чтобы они давали общее представление о вашем юридическом споре. <br/><br/>Например: <br/> «В мае 2019 года арендатор, проживающий в моей арендованной недвижимости, не платит арендную плату уже 6 месяцев. Я хочу получить поддержку от адвоката, специализирующегося в этой области.» <br/><br/>Пишите просто и ясно в таком стиле. Более подробные детали вы сможете обсудить с адвокатами, которые свяжутся с вами. <br/><br/>Ваши предпочтения будут проверены и подтверждены нашими специалистами по контролю качества. В результате проверки объявления с ошибками, неполными или неприемлемыми данными либо будут исправлены и опубликованы, либо удалены с сайта.`,
  "budget-info":
    "Уважаемый пользователь; В этом разделе вы можете выбрать предпочтительный бюджет, который готовы выделить на юридическую поддержку, чтобы быстрее найти нужного вам адвоката.",
  "contact-info":
    "Уважаемый пользователь; В этом разделе вы можете указать предпочтительные способы связи, через которые адвокаты, чьи предложения вы одобрили, смогут с вами связаться.",
  "deactivation-warning":
    "Если вы остановите своё объявление, вы потеряете все полученные на него предложения. Вы все равно хотите продолжить?",

  // Delegation Details
  city: "Город",
  district: "Район",
  "please-select-city": "Пожалуйста, выберите город",
  "please-select-district": "Пожалуйста, выберите район",
  "please-enter-short-desc-lawyer":
    "Пожалуйста, введите описание для ваших коллег",
  delegationAgreement: `Уважаемый пользователь-агент; Вы можете разместить объявление о сотрудничестве с другими коллегами для выполнения работ, на которые у вас есть полномочия, вместе с заявкой на "Объявление о партнерстве". Мы хотели бы напомнить вам о профессиональных обязанностях в отношении объявлений о сотрудничестве, и вы принимаете на себя все юридические и уголовные ответственности в случае нарушения обязательства о соответствии ваших объявлений как Закону об адвокатуре, так и Конституции, всем законам и нормативным актам, с момента отправки запроса на публикацию этого объявления.`,

  // CaseItem Search
  "no-search-result":
    "По вашим критериям поиска результатов не найдено, пожалуйста, попробуйте поиск с другими словами.",
  "order-by": "Сортировать",
  "filter-by": "Фильтровать",
  budgetAsc: "Бюджет ↑",
  budgetDesc: "Бюджет ↓",
  createDateAsc: "Дата создания ↑",
  createDateDesc: "Дата создания ↓",
  userProvinceAsc: "Город проживания ↑",
  userProvinceDesc: "Город проживания ↓",
  caseTypeAsc: "Направление иска ↑",
  caseTypeDesc: "Направление иска ↓",

  // Lawyer Summary
  "citizen-cases": "Объявления граждан",
  "lawyer-cases": "Объявления о партнерстве",
  "see-more-cases-lawyer": "Показать больше объявлений...",
  "lawyer-offer-info":
    "Пожалуйста, выберите ценовой диапазон, который вы предлагаете для вашего клиента.",
  "open-offers": "Ожидающие предложения",
  "new-offer": "у вас есть предложение, которое еще не опубликовано.",
  "approved-offers": "Подтвержденные предложения",
  "rejected-offers": "Отклоненные предложения",
  "on-hold-offers": "Ваши приостановленные предложения",
  "see-more-offers": "Нажмите, чтобы увидеть другие ваши предложения.",

  // OfferItem
  "offer-for-this-case": "Вы рассматриваете предложение по вашему объявлению.",
  "lawyer-message": "Сообщение представителя",
  offers: "Предложения",
  "no-offer-for-case":
    "В настоящее время отсутствует какое-либо предложение по этому объявлению",
  "phone-required-to-accept-offer":
    "Для того чтобы вы могли принимать предложения, в системе должен быть зарегистрирован ваш номер телефона.",
  "you-rejected-offer": "Вы отклонили предложение",
  "offer-on-hold":
    "Поскольку вы начали соглашение по другому предложению, это предложение было приостановлено.",
  "start-agreement": "Начать сделку",
  "started-agreement":
    "По этому предложению вы начали соглашение, ваши контактные данные были переданы представителю. В течение 2 недель вы можете отменить соглашение и рассмотреть другие предложения, в противном случае ваше объявление будет автоматически завершено.",
  "abort-agreement": "Отменить соглашение",
  "bar-number": "Номер коллегии адвокатов",
  "no-client-action": "Клиент пока не рассмотрел ни одного предложения.",
  "your-offer": "Ваше предложение",
  "your-offer-sent": "Ваше предложение было отправлено",
  "your-offer-rejected": "Ваше предложение было отклонено",
  "client-on-hold-offer":
    "Клиент приостановил рассмотрение этого предложения, поскольку начал переговоры по другому варианту. Если он отменит текущее соглашение, ваше предложение будет вновь рассмотрено.",
  "client-reject-offer": "Клиент отклонил ваше предложение.",
  "client-accepted-offer": "Клиент принял ваше предложение.",
  "client-preferred-contact": "Контактные данные, предпочитаемые клиентом",
  "client-information": "Информация о клиенте.",
  "confirm-offer-approve":
    "Внимание: после принятия предложения ваши контактные данные будут переданы его владельцу, и в течение 2 дней вы не сможете отменить предложение. Вы подтверждаете это?",
  user_approved_other_offer:
    "Владелец объявления рассматривал другое предложение",

  // Admin
  documents: "Документы",
  "please-type-keyword": "Пожалуйста, введите данные в поле поиска.",
  "no-result": "Результатов не найдено.",
  "admin-panel": "Панель управления доверенностями",
  "approval-pending-cases": "Объявления, ожидающие подтверждения",
  "select-cases-to-process":
    "Вы можете выбрать объявления, с которыми хотите провести операцию",
  "case-owner": "Владелец объявления",
  "approve-selected-cases": "Вы уверены, что хотите одобрить эти объявления?",
  "reject-selected-cases": "Пожалуйста, кратко укажите причину отклонения:",
  "reject-reason": "Причина отклонения",
  "reject-reason-minlength": "Пожалуйста, введите не менее 10 символов.",
  "reject-reason-maxlength": "Пожалуйста, не вводите более 100 символов.",
  block: "Заблокировать",
  unblock: "Снять блокировку",
  activate: "Опубликовать",
  deactivate: "Остановить",
  "activate-user": "Activate",
  "approval-pending-lawyers": "Заявки доверенных лиц, ожидающие одобрения",
  "user-roles": "Роли пользователя",

  // Premium
  subscribePremiumNow: "УВЕЛИЧЬТЕ ДО ПРЕМИУМА ПРЯМО СЕЙЧАС",
  premiumPageTitle: "Переходите к Премиуму!",
  premiumPageSubtitle:
    "Уважаемый пользователь, став нашим привилегированным клиентом по доступной цене, вы сможете отправлять неограниченное количество предложений и доводить их до большего числа граждан.",
  creditCardInformation: "Сведения о кредитной карте",
  cardHolderName: "Имя и фамилия владельца карты",
  cardNumber: "Номер карты",
  expirationMonth: "Месяц",
  expirationYear: "Год",
  cvv: "Код безопасности (CVV)",
  "card-holder-required": "Это поле обязательно для заполнения",
  "card-holder-minLength": "Пожалуйста, введите не менее 6 символов",
  "card-holder-maxLength": "Вы можете ввести максимум 60 символов",
  "card-holder-pattern": "Пожалуйста, введите только буквы",
  "card-number-required": "Это поле обязательно для заполнения",
  "card-number-minLength":
    "Пожалуйста, полностью укажите 16-значный номер карты",
  "card-number-maxLength": "Номер карты должен состоять из 16 цифр",
  "card-number-pattern": "Пожалуйста, введите только цифры",
  "expiration-month-required": "Это поле обязательно для заполнения",
  "expiration-month-minLength": "Пожалуйста, введите 2-значный месяц",
  "expiration-month-maxLength": "Месяц должен состоять из 2 цифр",
  "expiration-month-pattern": "Пожалуйста, введите только цифры",
  "expiration-month-max": "Месяц не должен превышать 12",
  "expiration-month-min": "Месяц должен быть не менее 01",
  "expiration-year-required": "Это поле обязательно для заполнения",
  "expiration-year-minLength": "Пожалуйста, введите 4-значный год",
  "expiration-year-maxLength": "Год должен состоять из 4 цифр",
  "expiration-year-pattern": "Пожалуйста, введите только цифры",
  "cvv-required": "Это поле обязательно для заполнения",
  "cvv-minLength":
    "Пожалуйста, введите 3-значный код CVV на обратной стороне карты",
  "cvv-maxLength": "Код CVV должен состоять из 3 цифр",
  "cvv-pattern": "Пожалуйста, введите только цифры",
  "make-payment": "Произвести оплату",

  // CaseItem Categories
  "c-1": "Уголовные иски",
  "c-2": "Частные и общественные иски",
  "c-3": "Другие взыскательные и иностранные процедуры",
  "c-1-b-1": "Суд общей юрисдикции по уголовным делам",
  "c-1-b-2": "Суд по тяжким уголовным делам",
  "c-1-b-3": "Расследования прокуратуры",
  "c-2-b-1": "Семейное право",
  "c-2-b-2": "Торговое право",
  "c-2-b-3": "Мирное гражданское право",
  "c-2-b-4": "Кадастровый суд",
  "c-2-b-5": "Потребительский суд",
  "c-2-b-6": "Трудовой суд",
  "c-2-b-7": "Гражданский суд первой инстанции",
  "c-2-b-8": "Суд по интеллектуальной собственности",
  "c-2-b-9": "Другое",
  "c-2-b-10": "Административные иски",
  "c-3-b-1": "Процедуры для иностранных граждан",
  "c-3-b-2": "Консультации",
  "c-3-b-3": "Взыскание",
  "c-1-b-1-s-1": "Кражи",
  "c-1-b-1-s-2": "Половые преступления",
  "c-1-b-1-s-3": "Оскорбления",
  "c-1-b-1-s-4": "Угрозы",
  "c-1-b-1-s-5": "Ранения",
  "c-1-b-1-s-6": "Повреждение имущества",
  "c-1-b-1-s-7": "Мошенничество",
  "c-1-b-1-s-8": "Злоупотребление доверием",
  "c-1-b-1-s-9": "Использование и хранение наркотиков",
  "c-1-b-1-s-10": "Подделка",
  "c-1-b-1-s-11": "Киберпреступления",
  "c-1-b-1-s-12": "Другое",
  "c-1-b-2-s-1": "Продажа наркотиков",
  "c-1-b-2-s-2": "Организованная преступность",
  "c-1-b-2-s-3": "Подделка",
  "c-1-b-2-s-4": "Половое насилие",
  "c-1-b-2-s-5": "Разбой",
  "c-1-b-2-s-6": "Контрабанда",
  "c-1-b-2-s-7": "Убийство",
  "c-1-b-2-s-8": "Другое",
  "c-1-b-3-s-1": "Подозреваемый арестован",
  "c-1-b-3-s-2": "Подозреваемый не арестован",
  "c-1-b-3-s-3": "Подача жалобы",
  "c-2-b-1-s-1": "Иски по наследству",
  "c-2-b-1-s-2": "Иски по разводу",
  "c-2-b-1-s-3": "Назначение опекуна / временного управляющего",
  "c-2-b-1-s-4": "Иск о выплате алиментов",
  "c-2-b-1-s-5": "Иск об опеке",
  "c-2-b-1-s-6":
    "Требования о запрете приближения и другие меры предосторожности",
  "c-2-b-1-s-7": "Другое",
  "c-2-b-2-s-1": "Иски о взыскании задолженности",
  "c-2-b-2-s-2": "Другое",
  "c-2-b-3-s-1": "Иски по аренде",
  "c-2-b-3-s-2":
    "Иски по управлению жилыми комплексами / многоквартирными домами (ЖКХ)",
  "c-2-b-3-s-3":
    "Иски о прекращении товарищества/партнерства (продажа общего имущества)",
  "c-2-b-3-s-4": "Другое",
  "c-2-b-4-s-1": "Кадастровый суд",
  "c-2-b-5-s-1": "Взыскание долгов",
  "c-2-b-5-s-2": "Компенсация",
  "c-2-b-5-s-3": "Заявление в арбитражный совет",
  "c-2-b-5-s-4": "Другое",
  "c-2-b-6-s-1": "Претензии работников",
  "c-2-b-6-s-2": "Компенсация",
  "c-2-b-6-s-3": "Восстановление на работе",
  "c-2-b-6-s-4": "Другое",
  "c-2-b-7-s-1": "Споры по недвижимости",
  "c-2-b-7-s-2": "Взыскание долгов",
  "c-2-b-7-s-3": "Другое",
  "c-2-b-8-s-1": "Иски по товарным знакам, патентам и т.д.",
  "c-2-b-9-s-1": "Другое",
  "c-2-b-10-s-1": "Иски об аннулировании административных решений",
  "c-2-b-10-s-2": "Иски о компенсации в административных делах",
  "c-2-b-10-s-3": "Другое",
  "c-2-b-10-s-4": "Налоговые иски",
  "c-3-b-1-s-1": "Процедуры гражданства",
  "c-3-b-1-s-2": "Процедуры получения разрешения на проживание",
  "c-3-b-1-s-3": "Процедуры получения разрешения на работу",
  "c-3-b-1-s-4": "Процедуры обжалования депортации",
  "c-3-b-1-s-5": "Визовые процедуры",
  "c-3-b-1-s-6": "Консультационные процедуры",
  "c-3-b-1-s-7": "Другое",
  "c-3-b-2-s-1": "Устные консультации (на основе встреч)",
  "c-3-b-2-s-2": "Письменные консультации (для подготовки документов)",
  "c-3-b-2-s-3": "Представительство в медиации",
  "c-3-b-2-s-4": "Другое",
  "c-3-b-3-s-1": "Представительство кредиторов",
  "c-3-b-3-s-2": "Представительство должников",
  "c-3-b-3-s-3": "Другое",
};

export default dictionary;
